import React, { useRef } from 'react';
import { CreateButtonModal } from '@/components/shared/button/CreateButton';
import { ITestIssueSchema } from '@/api/testIssue';
import { CommentForm } from './CommentForm';
import { Drawer, DrawerRef } from '@/components/shared/panel/Drawer';

interface AddCommentFormProps {
  testIssue: ITestIssueSchema;
  onSuccess?: () => void;
}

const AddCommentForm: React.FC<AddCommentFormProps> = ({
  testIssue,
  onSuccess,
}) => {
  const ref = useRef<DrawerRef>(null);
  return (
    <>
      <button onClick={() => ref.current?.open()}>
        <CreateButtonModal label="Add Comment" />
      </button>

      <Drawer ref={ref}>
        <CommentForm
          testIssue={testIssue}
          onSuccess={() => {
            ref.current?.close();
            onSuccess?.();
          }}
          closeModal={ref.current?.close}
        />
      </Drawer>
    </>
  );
};

export default AddCommentForm;
